import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {  Outlet, useLocation, useNavigate } from 'react-router-dom';
import { APP_LINKS } from '@/helpers/links';
import { Tabs } from './components/Tabs';
import s from './index.module.scss';

const TABS = t => [
  { label: t('your_loans'), path: APP_LINKS.loansList },
  { label: t('repayment_schedule'), path: APP_LINKS.loansSchedule },
];

const LoansPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('loans');

  useEffect(() => {
    if (location.pathname === APP_LINKS.loans) {
      navigate(APP_LINKS.loansList, { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <div className={s.page}>
      <div className="container-inner">
        <h1 className="f-hero-h2">{t('loans')}</h1>
        <Tabs links={TABS(t)} />
        <Outlet />
      </div>
    </div>
  );
};

export default LoansPage;
